import React from 'react';
import * as S from './suspected-popup-style';
import Image from '../../common/Image';
import ParentImage from './parent-image.svg';
import TeacherImage from './teacher-image.svg';
import { trackToGtmFE } from '../../../../utils/gtm-event-common';
import { isMobileDevice, setCookieWithAge } from '../../../../utils/web-helper';
var SuspectedPopup = function (props) {
    var headingText = "Welcome! Are you joining as a parent or teacher?";
    var mailText = props.email;
    var text = ' seems like a school or work email.';
    var parentText = "I’m a parent";
    var teacherText = "I’m a teacher";
    var parentFeatureText = "Accelerate your child’s learning with effective independent practice.";
    var teacherFeatureText = "Empower your classroom with personalised learning for every student.";
    var ctaParentText = "Continue as a parent";
    var ctaTeacherText = "Continue as a teacher";
    React.useEffect(function () {
        var eventName = "viewed_suspected_signup_popup";
        trackToGtmFE(eventName, { "Parent Signup Method": getSignupMethod() });
        var contentElement = document.getElementById('content');
        if (contentElement && isMobileDevice()) {
            contentElement.style.paddingTop = '0px';
            contentElement.style.height = "".concat(window.innerHeight, "px");
            document.body.style.position = 'fixed';
        }
        return function () {
            if (contentElement) {
                contentElement.style.paddingTop = '';
                contentElement.style.height = "".concat(window.innerHeight, "px");
                document.body.style.position = 'unset';
            }
        };
    }, []);
    var getSignupMethod = function () {
        return (localStorage.getItem('parent_signup_method') || "email");
    };
    var handleCtaClick = function (event, userType) {
        setCookieWithAge('suspected_popup_status', 'suspected_popup_seen');
        if (userType == 'parent') {
            var eventName = 'interacted_suspected_signup_popup_parent';
            trackToGtmFE(eventName, { 'Parent Signup Method': getSignupMethod(), 'Click Text': 'Continue as a parent' });
            props.onParentCtaClick(event);
        }
        else {
            var eventName = 'interacted_suspected_signup_popup_teacher';
            trackToGtmFE(eventName, { 'Parent Signup Method': getSignupMethod(), 'Click Text': 'Continue as a teacher' });
            props.onTeacherCtaClick();
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(S.OverlayStyle, null,
            React.createElement(S.PopupContainer, null,
                React.createElement(S.HeadingStyle, null, headingText),
                React.createElement(S.MailTextStyle, { afterText: text }, mailText),
                React.createElement(S.CardRow, null,
                    React.createElement(S.CardColoumn, null,
                        React.createElement(Image, { src: ParentImage, alt: "popup-image" }),
                        React.createElement(S.UserText, null, parentText),
                        React.createElement(S.FeatureText, null, parentFeatureText),
                        React.createElement(S.CtaStyle, { isParentCta: true, onClick: function (event) { handleCtaClick(event, "parent"); } }, ctaParentText)),
                    React.createElement(S.CardColoumn, null,
                        React.createElement(Image, { src: TeacherImage, alt: "popup-image" }),
                        React.createElement(S.UserText, null, teacherText),
                        React.createElement(S.FeatureText, null, teacherFeatureText),
                        React.createElement(S.CtaStyle, { isParentCta: false, onClick: function (event) { handleCtaClick(event, "teacher"); } }, ctaTeacherText))))));
};
export default SuspectedPopup;
